var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"problem-container",attrs:{"id":"section2"}},[_c('div',{staticStyle:{"margin-top":"75px"}},[_c('div',{staticClass:"problem-txt"},[_vm._v(_vm._s(_vm.$t('message.The-Problems')))]),_c('br'),_c('br')]),_c('div',{staticClass:"problem-download"},[_c('problem-one'),_c('problem-two'),_c('problem-three')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }